import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from 'src/domains/common/universes/betwright/betwright.features';
import { themeColors } from 'src/domains/common/universes/betwright/betwright.config';
import { BetWrightLogotype } from 'src/domains/common/universes/betwright/betwright.logotype';
import BetWrightLoginImage from 'src/layouts/LoginPage/loginBgImages/BetWrightLoginImage.png';
import { BetWrightLogo } from 'src/layouts/LoginPage/logos/BetWrightLogo';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';
import { BetwrightBrandIconWrapper, CompliancePopupLogo } from './betwright.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'BetWright Backoffice',
    urls: {
        website: 'https://www.betwright.com/',
        backoffice: 'https://backoffice.betwright.com/',
    },
    BrandIcon: () => <BetwrightBrandIconWrapper />,
    Logotype: () => <BetWrightLogotype />,
    LogotypeLoginPage: () => <BetWrightLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={BetWrightLoginImage} />,
};
